import { Text } from '@tremor/react';
import { formatExportedAt } from '../lib/format';
import { t } from '../lib/i18n';
import type { ExportMeta } from '../api/types';

interface Props { meta: ExportMeta | null; }

export default function FreshnessFooter({ meta }: Props) {
  return (
    <footer className="px-6 py-3 text-center">
      <Text className="text-tremor-content text-xs">
        {t.freshness.asOf} {meta ? formatExportedAt(meta.exported_at) : t.freshness.never}
      </Text>
    </footer>
  );
}
